import React, { Component } from 'react';
import { Redirect,Route } from 'react-router-dom';

var global = {
    username: '',
   
}

function theGlobal(){
    var a = {
        username: '',
        createdAt: Date.now(),
    }
    var self = this;
    Object.defineProperty(a, "warehouse", {
        set(value) {
            this._warehouse = value;
            localStorage.setItem("warehouse", value);
        },
        get() {
            return this._warehouse;
        }
    });
    Object.defineProperty(a, "warehouse_name", {
        set(value) {
            this._warehouse_name = value;
            localStorage.setItem("warehouse_name", value);
        },
        get() {
            return this._warehouse_name;
        }
    });
    Object.defineProperty(a, "print_settings", {
        set(value) {
            this._print_settings = value;
            localStorage.setItem("print_settings", value);
        },
        get() {
            return this._print_settings;
        }
    });
    Object.defineProperty(a, "carrier_settings", {
        set(value) {
            this._carrier_settings = value;
            localStorage.setItem("carrier_settings", value);
        },
        get() {
            return this._carrier_settings;
        }
    });
    Object.defineProperty(a, "isStockCounted", {
        set(value) {
            this._isStockCounted = value;
            localStorage.setItem("isStockCounted", value);
        },
        get() {
            return this._isStockCounted;
        }
    });

    Object.defineProperty(a, "selected_stocktake", {
        set(value) {
            this._selected_stocktake = value;
            localStorage.setItem("selected_stocktake", value);
        },
        get() {
            return this._selected_stocktake;
        }
    });

    Object.defineProperty(a, "stocktake_loc_details", {
        set(value) {
            this._stocktake_loc_details = value;
            localStorage.setItem("stocktake_loc_details", value);
        },
        get() {
            return this._stocktake_loc_details;
        }
    });
   
    Object.defineProperty(a, "user", {
        set(value) {
            this._user = value;
            localStorage.setItem("user", value);
        },
        get() {
            return this._user;
        }
    });
    Object.defineProperty(a, "userLevel", {
        set(value) {
            this._userLevel= value;
            localStorage.setItem("userLevel", value);
        },
        get() {
            return this._userLevel;
        }
    });
    Object.defineProperty(a, "staffName", {
        set(value) {
            this._staffName = value;
            localStorage.setItem("staffName", value);
        },
        get() {
            return this._staffName;
        }
    });
    Object.defineProperty(a, "rf_transfer", {
        set(value) {
            this._rf_transfer = value;
            localStorage.setItem("rf_transfer", value);
        },
        get() {
            return this._rf_transfer;
        }
    });
    Object.defineProperty(a, "locationChargesConfirmedByUser", {
        set(value) {
            this._locationChargesConfirmedByUser = value;
            localStorage.setItem("locationChargesConfirmedByUser", value);
        },
        get() {
            return this._locationChargesConfirmedByUser;
        }
    });
    Object.defineProperty(a, "locationChargesConfirmed_LocationId", {
        set(value) {
            this._locationChargesConfirmed_LocationId = value;
            localStorage.setItem("locationChargesConfirmed_LocationId", value);
        },
        get() {
            return this._locationChargesConfirmed_LocationId;
        }
    });
    a.userAllowed = (levels) => {
        return levels.indexOf(a.userLevel) >= 0;
    };

    a.login = (user) => {
        MyGlobal.user = user.id;
        MyGlobal.userLevel = user.title;
        MyGlobal.staffName = user.Staff_Name;
    }
    a.hasWarehouse = () => {
        return MyGlobal.warehouse != "";
    }
    a.logout = () => {
        MyGlobal.user = "";
        MyGlobal.userLevel = "";
        MyGlobal.warehouse = "";
        MyGlobal.staffName = "";
    }
    a.isAuthed= () => {
        return MyGlobal.user != "";
    };
    a.warehouse = localStorage.getItem("warehouse") ?? "";
    a.warehouse_name = localStorage.getItem("warehouse_name") ?? "";
    a.userLevel = localStorage.getItem("userLevel") ?? "";
    a.user = localStorage.getItem("user") ?? "";
    a.print_settings = localStorage.getItem("print_settings") ?? "";
    a.carrier_settings = localStorage.getItem("carrier_settings") ?? "";
    a.staffName = localStorage.getItem("staffName") ?? "";
    a.selected_stocktake = localStorage.getItem("selected_stocktake") ?? "";
    a.stocktake_loc_details = localStorage.getItem("stocktake_loc_details") ?? "";
    a.isStockCounted = localStorage.getItem("isStockCounted") ?? "true";
    a.rf_transfer = localStorage.getItem("rf_transfer") ?? "";
    a.locationChargesConfirmedByUser = localStorage.getItem("locationChargesConfirmedByUser") ?? "";
    a.locationChargesConfirmed_LocationId = localStorage.getItem("locationChargesConfirmed_LocationId") ?? "";
    a.backOK = true;
    a.strings = {
        scanCarton: "Scan Carton/Tote",
        needApproval: "Carton Needs Approval",
        scanLocation: "Scan Location",
        invalidLocation: "This does NOT appear to be a location",
        invalidQty:"Invalid Quantity",
        unableToUseLocation: "This location is unable to be used due to status",
        normalStatus: "NORMAL",
        scanToConfirm: "Scan Location To Confirm",
        locationDontMatch: "Location Don't Match Scan Location",
        requiresSupervisor: "Requires Supervisor Access",
        sending:"Sending....",
    }
    
    return a ;
}

export const MyGlobal = theGlobal();

export const MyContext = React.createContext(global);
export class GlobalContextProvider extends Component {
    render() {
        return <MyContext.Provider value={global}>
            {this.props.children}
        </MyContext.Provider>
    }
}

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        //logErrorToMyService(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <div className="alert alert-danger" role="alert">
               Something went wrong!!
            </div>;
        }

        return this.props.children;
    }
}
export function GlobalContextConsumer({children}) { //not working?
    return <MyContext.Consumer>
        {context => children(context)};
    </MyContext.Consumer>
    
}


export function MyHeading({ children }) {
    return <h4>
        {children}
    </h4>
}

export function MyAlert({ children }) {
    return <div className="alert alert-danger" role="alert">
        {children}
    </div>
}


export function MyAuthRoute(props) {
    let authenticated = MyGlobal.isAuthed();

    const { component: Component, ...rest } = props;
    return <Route {...rest}
        render={(props) => {
            if (authenticated) {
                return <Component {...props} />
            } else {
                return <Redirect to={"/"} />
            }
        }} />

}


export function MyWarehouseRoute(props) {
    

    const { component: Component, ...rest } = props;
    return <Route {...rest}
        render={(props) => {
            if (MyGlobal.isAuthed() && MyGlobal.hasWarehouse()) {
                return <Component {...props} />
            }
            else {
                return <Redirect to={"/"} />
            }
        }} />

}

